import { OptionDefinition, OptionValues, OptionSection } from '../types/optionTypes';
import { evaluateCondition } from './logicEvaluator';

export interface ValidationError {
    elementId: string;
    message: string;
}

export const validateOptions = (
    optionData: OptionDefinition[],
    values: OptionValues,
    selectedProduct?: any
): Record<string, string> => {
    const errors: Record<string, string> = {};

    optionData.forEach(sectionDef => {
        // Check section visibility first
        if (sectionDef.fields) {
            Object.values(sectionDef.fields).forEach((section: OptionSection) => {
                // Check if section is visible
                let isSectionVisible = true;
                if (section.extra.enableCl && section.extra.relations) {
                    const context = { values, product: selectedProduct };
                    const isConditionMet = evaluateCondition(section.extra.relations as any, context);
                    isSectionVisible = section.extra.cl_rule === 'show' ? isConditionMet : !isConditionMet;
                } else if (section.extra.cl_rule === 'hide' && section.extra.enableCl) {
                    isSectionVisible = false;
                }

                if (!isSectionVisible) return;

                // Iterate through fields
                section.fields.forEach(row => {
                    row.forEach(field => {
                        // Check field visibility
                        let isFieldVisible = true;
                        if (field.enableCl && field.relations) {
                            const context = { values, product: selectedProduct };
                            const isConditionMet = evaluateCondition(field.relations as any, context);
                            isFieldVisible = field.cl_rule === 'show' ? isConditionMet : !isConditionMet;
                        } else if (field.cl_rule === 'hide' && field.enableCl) {
                            isFieldVisible = false;
                        }

                        if (!isFieldVisible) return;

                        const value = values[field.name];

                        // Required check
                        if (field.required) {
                            if (value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0)) {
                                errors[field.name] = '必須項目です';
                            }
                        }

                        // Additional validation based on type
                        if (value) {
                            if (field.type === 'text' || field.type === 'textarea') {
                                // Max length check if needed (not in types yet but good practice)
                            }

                            // Number validation
                            if (field.type === 'text' && (field as any).subtype === 'number') {
                                const numVal = Number(value);
                                if (isNaN(numVal)) {
                                    errors[field.name] = '数値を入力してください';
                                }
                            }
                        }
                    });
                });
            });
        }
    });

    return errors;
};
